import { SearchInput } from "@volca/ui/components/ui/search-input";
import { Stack } from "@volca/ui/components/ui/stack";
import { SwitchWithLabel } from "@volca/ui/components/ui/switch-with-label";
import {
  TimeRangePicker,
  TimeRange,
} from "@volca/ui/components/ui/time-range-picker";

interface ReferralHistoryToolbarProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onlyActiveReferrals: boolean;
  onOnlyActiveReferralsChange: (value: boolean) => void;
  timeRange: TimeRange | null;
  onTimeRangeChange: (value: TimeRange | null) => void;
}

export const ReferralHistoryToolbar = ({
  searchValue,
  onSearchChange,
  onlyActiveReferrals,
  onOnlyActiveReferralsChange,
  timeRange,
  onTimeRangeChange,
}: ReferralHistoryToolbarProps) => (
  <Stack
    gap={4}
    direction="row"
    justify="between"
    align="center"
    className="w-full shrink-0 flex-wrap gap-y-2 pr-5"
  >
    <Stack direction="row" align="center" gap={4} className="flex-wrap gap-y-2">
      <SearchInput
        placeholder="Search referrals"
        value={searchValue}
        onChange={onSearchChange}
      />
      <SwitchWithLabel
        label="Active referrals only"
        checked={onlyActiveReferrals}
        onChange={onOnlyActiveReferralsChange}
      />
    </Stack>
    <TimeRangePicker
      value={timeRange}
      onChange={onTimeRangeChange}
      placeholder="Select date range"
    />
  </Stack>
);
